import * as types from '../constants/actionTypes';

const initialState = {
  // productHistory keyed by productId: array of entries
  productHistory: {},
  // vendorHistory keyed by vendorId
  vendorHistory: {},
  inflationReport: [],
  loading: false,
  error: null,
};

const priceHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PRODUCT_PRICE_HISTORY_REQUEST:
    case types.FETCH_VENDOR_PRICE_HISTORY_REQUEST:
    case types.FETCH_PRICE_INFLATION_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_PRODUCT_PRICE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        productHistory: {
          ...state.productHistory,
          [action.payload.productId]: action.payload.data,
        },
      };

    case types.FETCH_VENDOR_PRICE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        vendorHistory: {
          ...state.vendorHistory,
          [action.payload.vendorId]: action.payload.data,
        },
      };

    case types.FETCH_PRICE_INFLATION_SUCCESS:
      return { ...state, loading: false, inflationReport: action.payload || [] };

    case types.FETCH_PRODUCT_PRICE_HISTORY_FAILURE:
    case types.FETCH_VENDOR_PRICE_HISTORY_FAILURE:
    case types.FETCH_PRICE_INFLATION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default priceHistoryReducer;
